import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { SessionThemes } from '../../helpers/schema';
import { themeTokensSchema } from './create_POST.schema';

export const schema = z.object({
  themeId: z.string(),
  name: z.string().min(1).max(100).optional(),
  description: z.string().max(500).optional().nullable(),
  tokens: themeTokensSchema.optional(),
  imagePrompt: z.string().optional().nullable(),
  imageUrl: z.string().url().optional().nullable(),
  setActive: z.boolean().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  theme: Selectable<SessionThemes>;
};

export const updateTheme = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const result = await fetch('/_api/themes/update', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
